import {ObjectIndex} from '../common/index/ObjectIndex';
import {isObject} from './isObject';
import {isArray} from './isArray';

export function isPlainObject(o?: any): o is Record<ObjectIndex, unknown> {
    return isObject(o) && !isArray(o);
}
